<template>
  <div class="fixed-layout">

    <!-- 내용 영역 -->
    <div class="content">
      <div class="title mt-3 mb-4">
        <p class="h2"><b>{{ titleText }}</b></p>
      </div>

      <div class="text mb-4">
        <p class="h6">{{ subTitle }}</p>
      </div>

      <div class="mb-4">
        <p ref="RESULT" class="fs-6 fw-bold"></p>
      </div>

    </div>

    <!-- 버튼 영역 -->
    <div class="buttons">
      <button
          class="btn btn-dark btn-lg rounded-pill w-100 mb-3"
          @click="goNext"
      >
        {{ buttonLabel }}
      </button>
    </div>

  </div>
</template>

<script>
import { Join } from "@/js/user/Join.js";
import { router } from "@/router/index.js";

export default {
  props: {
    userId: String,
    fromParams: Object
  },

  mounted() {
    this.setResult();
  },

  watch: {
    userId() {
      this.setResult();
    }
  },

  computed: {
    titleText() {
      return (!this.userId || this.userId.includes("No matching"))
          ? "No username found"
          : "Username found";
    },

    subTitle() {
      return (!this.userId || this.userId.includes("No matching"))
          ? "We could not find an account."
          : "We found your account.";
    },

    buttonLabel() {
      return (!this.userId || this.userId.includes("No matching"))
          ? "Back"
          : "Login";
    }
  },

  methods: {
    setResult() {
      const el = this.$refs.RESULT;

      if (!this.userId || this.userId.includes("No matching")) {
        // el.innerHTML = "<b>No matching username found.</b>";
        // Join.setColorClass(el, "red");
      } else {
        el.innerHTML = `<b>Your username is '${this.userId}'</b>`;
        Join.setColorClass(el, "blue");
      }
    },

    goNext() {
      if (!this.userId || this.userId.includes("No matching")) {
        this.$emit("back");
        return;
      }

      router.push({
        path: "/login",
        query: {
          cb: this.fromParams.cb,
          s: this.fromParams.s,
          c: this.fromParams.c
        }
      });
    }
  }
};
</script>

<style></style>
